<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />

            <td>
              {{ item.title }}
            </td>
            <td>
              {{ item.aliases }}
            </td>
            <td>
              {{ item.state }}
            </td>
            <td>
              {{ item.zip }}
            </td>

            <td class="text-center nowrap">
              <Actions
                hide-duplicate
                :path="`/schools/${item.id}`"
                @destroy="$emit('destroy', item)"
              >
              </Actions>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Title",
          align: "start",
          value: "name",
        },
        {
          text: "Aliases",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "State",
          align: "start",
          sortable: true,
        },
        {
          text: "Postal Code",
          align: "start",
          sortable: true,
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style></style>
